import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import { Input } from 'reactstrap'
import { DebounceInput } from './DelayInput/DelayInput'
import _ from 'common-tools/LodashHelper'

class TextBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    type: pt.string,
    delay: pt.bool
  })

  static defaultProps = {
    delay: false
  }

  onChange (event) {
    const { input: { onChange } } = this.props
    if (_.isString(event)) {
      onChange(event)
    } else if (_.has(event, 'target.value')) {
      onChange(event.target.value)
    } else {
      onChange(undefined)
    }
  }

  render () {
    const { type, delay, styles, ...rest } = this.props
    var inputType = type || 'text'
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, name, placeHolder, loading, readonly }) => {
          if (readonly) {
            return <Input type='text' style={styles} readOnly name={`view${name}`} id={`view${name}`} value={value} />
          } else {
            if (delay === true) {
              return <DebounceInput style={styles} className='form-control' minLength={2} delayTimeout={300} type={inputType} invalid={showError} name={`text${name}`} id={`text${name}`} placeholder={placeHolder} onChange={this.onChange.bind(this)} value={value} />
            } else {
              return <Input style={styles} type={inputType} invalid={showError} name={`text${name}`} id={`text${name}`} placeholder={placeHolder} onChange={onChange} value={value} />
            }
          }
        }}
      </FieldLayoutBox>
    )
  }
};

export const TextBox = ({ parse, format, fieldType, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={TextBoxClass} /> } // eslint-disable-line
export default TextBox
